import React, { useState } from "react";
import PropTypes from "prop-types";

const faqs = [
  {
    question: "1. How accurate are your AI job matches?",
    answer:
      "Our AI analyzes your skills, experience, and goals to deliver matches with 85%+ relevance scores —way better than generic job alerts.",
  },
  {
    question: "2. How fast does the AI resume builder work?",
    answer:
      "Our AI resume builder can optimize your resume in under 2 minutes, analyzing industry trends and job requirements to enhance your profile.",
  },
  {
    question: "3. Do you help with cover letters too?",
    answer:
      "Yes! Our platform includes AI-powered cover letter generation that creates personalized cover letters tailored to each job application.",
  },
  {
    question: "4. Can I track my job applications?",
    answer:
      "Absolutely! Our dashboard provides comprehensive application tracking with status updates, interview scheduling, and follow-up reminders.",
  },
  {
    question: "5. Can I use SeekJobs if I need visa sponsorship?",
    answer:
      "Yes, our platform specifically filters and highlights opportunities from employers who provide visa sponsorship for international candidates.",
  },
  {
    question: "6. What if I do not know what career I want?",
    answer:
      "Our career assessment tools and AI-powered career guidance help you discover your strengths and explore career paths that match your interests and skills.",
  },
];

function FrequentQuation({ items = [], className = "" }) {
  const [expandedIndex, setExpandedIndex] = useState(null); // First open

  const toggleFAQ = (index) => {
    setExpandedIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="tw-py-20">
      <div className="tw-px-4 sm:tw-px-6 lg:tw-px-32">
        <div className="tw-relative">
          <h2
            className="tw-font-inter tw-font-semibold tw-text-[36px] sm:tw-text-[48px] lg:tw-text-[66px] tw-leading-[44px] sm:tw-leading-[58px] lg:tw-leading-[80px] tw-text-global-6 tw-text-center tw-mb-10 sm:tw-mb-14 lg:tw-mb-16"
            style={{ textShadow: "0px 0px 50px #3076ce" }}
          >
            Frequently Asked Questions
          </h2>

          <div className="tw-space-y-3">
            {faqs.map((faq, index) => (
              <div key={index}>
                <div
                  onClick={() => toggleFAQ(index)}
                  className={`tw-rounded-[12px] tw-cursor-pointer tw-transition-all ${expandedIndex === index ? "tw-bg-global-2" : ""
                    }`}
                  style={{ padding: "10px" }}
                >
                  <div className="tw-flex tw-justify-between tw-items-center">
                    <h3 className="tw-font-inter tw-font-semibold tw-text-[16px] sm:tw-text-[18px] lg:tw-text-[19px] tw-leading-[24px] sm:tw-leading-[26px] tw-text-global-6">
                      {faq.question}
                    </h3>
                    {expandedIndex === index && (<img
                      src="/images/img_caret.svg"
                      alt="Toggle"
                      className={`tw-w-5 sm:tw-w-6 tw-h-5 sm:tw-h-6 tw-transition-transform `}
                    />)}
                    {expandedIndex !== index && (<img
                      src="/images/img_caret.svg"
                      alt="Toggle"
                      className={`tw-w-5 sm:tw-w-6 tw-h-5 sm:tw-h-6 tw-transition-transform tw-rotate-180`}
                    />)}
                  </div>

                  {expandedIndex === index && (
                    <p className="tw-font-inter tw-font-medium tw-text-[14px] sm:tw-text-[16px] lg:tw-text-[19px] tw-leading-[22px] sm:tw-leading-[26px] tw-text-global-6 tw-mt-3 tw-pl-3 sm:tw-pl-6 lg:tw-pl-10">
                      {faq.answer}
                    </p>
                  )}
                </div>


                {index < faqs.length - 1 && (
                  <div className="tw-bg-global-7 tw-h-px tw-w-full tw-my-4"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

FrequentQuation.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    })
  ),
  className: PropTypes.string,
};

export default FrequentQuation;
